import { createAsyncThunk } from '@reduxjs/toolkit'
import { publicAxiosInstance } from '../../../services/createAxiosInstance';
import { handleApiError } from '../../../utils/handleApiError';
import { URLs } from '../../../constants/apiEndpoints';

//register user
export const registerUser = createAsyncThunk('auth/register', async ({ email, mobile, password, username }, { rejectWithValue }) => {
    try {
        const res = await publicAxiosInstance.post(URLs.REGISTER_URL, { email, mobile, password, username });
        return res.data;
    } catch (error) {
        const errorMessage = await handleApiError(error)
        throw rejectWithValue({ error: errorMessage });
    }
})

//User Login
export const loginUser = createAsyncThunk('auth/signin', async ({ email, password }, { rejectWithValue }) => {
    try {
        const res = await publicAxiosInstance.post(URLs.LOGIN_URL, { email, password });
        if (res.data) {
            return res.data;
        } // return empty object
    } catch (error) {
        const errorMessage = await handleApiError(error)
        throw rejectWithValue({ error: errorMessage })
    }
});


// forgot password
export const forgotUserPassword = createAsyncThunk('auth/forgotpassword', async ({ email }, { rejectWithValue }) => {
    try {
        const res = await publicAxiosInstance.post(URLs.FORGOT_PASSWORD_URL, { email });
        return res.data;
    } catch (error) {
        const errorMessage = await handleApiError(error)
        throw rejectWithValue({ error: errorMessage })
    }
});


// reset password
export const resetPassword = createAsyncThunk('auth/resetPassword', async ({ email, verificationCode, newPassword }, { rejectWithValue }) => {
    try {
        const res = await publicAxiosInstance.post(URLs.RESET_PASSWORD_URL, { email, verificationCode, newPassword });
        return res.data;
    } catch (error) {
        const errorMessage = await handleApiError(error)
        throw rejectWithValue({ error: errorMessage })
    }
});


// logout user
export const logout = createAsyncThunk('auth/logout', async ({ email }, { rejectWithValue }) => {

    try {
        const res = await publicAxiosInstance.post(URLs.LOGOUT_URL, { email });
        return res.data;
    } catch (error) {
        const errorMessage = await handleApiError(error)
        throw rejectWithValue({ error: errorMessage })
    }
});

// get confirm code
export const confirmCode = createAsyncThunk('auth/confirm', async ({ username, confirmationCode }, { rejectWithValue }) => {

    try {
        const res = await publicAxiosInstance.post(URLs.CONFIRM_CODE_VERIFY_URL, { username, confirmationCode });
        return res.data;
    } catch (error) {
        const errorMessage = await handleApiError(error)
        throw rejectWithValue({ error: errorMessage })
    }
});